import React, { useEffect, useRef, useState } from "react";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { useNavigate } from "react-router-dom";

import Topbar from "../../../Component/Topbar/Topbar";
import { Table } from "../../../Component/Table/Table";
import { edit, search, view } from "../../../assets/img";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import DateRange from "../../../Component/DateRange/DateRange";
import SelectBox from "../../../Component/SelectBox";
import { get, post } from "../../redux/api/ApiHandler";
import { URLS } from "../../redux/api/Constants";
import moment from "moment";
import toast from "react-hot-toast";
import useSearchFunction from "../../../Component/searchFunction";

const ClosedTable = () => {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [superAdmin, setSuperAdmin] = useState();
  const [pagination, setPagination] = useState("");
  const [selected, setSelected] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [regionOptions, setRegionOptions] = useState([]);
  const [fromDates, setFromDates] = useState(null);
  const [toDates, setToDates] = useState(null);
  const [selFrom, setSelFrom] = useState("");
  const [selTo, setSelTo] = useState("");

  const pageRef = useRef(1);

  const debounceval = useSearchFunction(searchValue);

  const ticketList = async (search, selected, fromDate, toDate) => {
    setSearchValue(search);
    setFromDates(fromDate);
    setToDates(toDate);
    setSelected(selected);

    let payload = {
      search: search,
      page: page,
      region_id: selected?.value,
      type: 4,
      from_date: fromDate ? moment(fromDate).format("DD-MM-YYYY") : "",
      to_date: toDate ? moment(toDate).format("DD-MM-YYYY") : "",
    };
    let res = await post(URLS.TICKET_LIST, payload);
    if (res?.status == "success") {
      setList(res?.lists);
      setPagination(res?.pagination_meta);
      pageRef.current = res?.pagination_meta?.current_page;
    }
  };

  const regionList = async () => {
    let res = await get(URLS.REGIONLIST);
    if (res?.status === "success" && Array.isArray(res?.roles)) {
      // 🔹 Convert API data to Select options
      const options = res?.roles.map((region) => ({
        value: region?.id,
        label: region?.name,
      }));
      setRegionOptions(options);
    }
  };

  useEffect(() => {
    ticketList(debounceval);
    regionList();
  }, [debounceval, page]);

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(pageRef.current - 1) * 10 + row.index + 1}</p>;
        },
      },

      {
        Header: "Regional Ticket ID",
        accessor: "code",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Region",
        accessor: "region",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Regional Manager",
        accessor: "regional_manager",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Service Engineer",
        accessor: "service_engineer",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Customer ID",
        accessor: "customer",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value?.code}</p>;
        },
      },
      {
        Header: "Customer Name",
        accessor: "customer.name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },

      {
        Header: "Created By",
        accessor: "created_by",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value.name}</p>;
        },
      },

      {
        Header: "Date",
        accessor: "opened_at",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap ">{moment(value).format("DD-MM-YYYY")}</p>
          );
        },
      },
      {
        Header: "Completed Date",
        accessor: "updated_at",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap ">{moment(value).format("DD-MM-YYYY")}</p>
          );
        },
      },

      {
        Header: "Actions",
        accessor: "",
        Cell: ({ value, row }) => {
          const status = row.original.status;
          return (
            <div className="d-flex ac-jc mt-2 gap-3">
              <button
                onClick={() => {
                  navigate("/closed-view", {
                    state: { type: "view", id: row?.original?.id },
                  });
                }}
                className="cust-btn "
              >
                <img src={view} alt="" className="editor-btn" />
              </button>
            </div>
          );
        },
      },
    ],
    [],
  );
  return (
    <>
      <Topbar header={"Ticket Closed"} />
      <div className="container_fluit1">
        <div className="d-flex ac-jb">
          <h4 className="f3 fs-sm-15 fs-md-19 fs-lg-20 fs-xl-22 fs-xxl-24">
            Total User : {pagination?.total}
          </h4>
        </div>
        <div className="d-flex ac-jb gap-4">
          <DateRange
            fromDate={fromDates}
            setFromDate={(val) =>
              ticketList(searchValue, selected, val, toDates)
            }
            toDate={toDates}
            setToDate={(val) =>
              ticketList(searchValue, selected, fromDates, val)
            }
          />

          <div className="col-md-2">
            <SelectBox
              options={regionOptions}
              selected={selected}
              setSelected={(val) =>
                ticketList(searchValue, val, fromDates, toDates)
              }
            />
          </div>

          <div className="search-input col-md-3 d-flex ac-jb my-4">
            <input
              value={searchValue}
              onChange={(e) =>
                setSearchValue(e.target.value, selected, fromDates, toDates)
              }
              type="text"
              placeholder="Search "
              className="search-field f2 fs-sm-13 fs-md-15 fs-lg-16 fs-xl-18 fs-xxl-20"
            />
            <img src={search} className="search" />
          </div>
        </div>
        <Table
          columns={columns}
          setPageno={setPage}
          pagecount={pagination}
          data={list ?? []}
          show={true}
        />
      </div>
    </>
  );
};

export default ClosedTable;
